/**
 * @providesModule FTUEConversionsTypes
 */

import {InterstitialProps} from '../../ViewComponents/InterstitialModal/InterstitialModal';

export type FTUEConversionsStep =
  /**
   * The user needs to play training matches against a bot
   *
   * This is currently fixed to 2 training matches by backend, but in the future
   * we should refactor this to support a dynamic number of matches driven by
   * game/client properties
   */
  | 'playTrainingMatch1'
  | 'playTrainingMatch2'

  /** The user needs to collect their trophy reward for winning a match */
  | 'claimTrophy'

  /** The user needs to play their first cash match */
  | 'playCashMatch'

  /** The user has completed the FTUE conversions flow */
  | 'completed';

/** The steps in the FTUE conversions flow in order */
export const ORDERED_CONVERSIONS_STEPS: FTUEConversionsStep[] = [
  'playTrainingMatch1',
  'playTrainingMatch2',
  'completed',
];

/** Maps a FTUEConversionsStep to a certain value, if applicable */
type FTUEConversionsStepMapping<T> = Partial<Record<FTUEConversionsStep, T>>;

/**
 * The number of interstitials we expect to show when a FTUEConversionsStep is
 * completed; this is currently hard-coded
 */
export const EXPECTED_INTERSTITIALS_PER_STEP: FTUEConversionsStepMapping<number> = {
  // TODO: Uncomment these when we actually have interstitials for the FTUE
  // playTrainingMatch1: 1, // The FTUE intro popup
  // playCashMatch: 2, // The hustler trophy popup and FTUE LTO
};

/**
 * The interstitials to show during the FTUE conversions flow
 * This maps a step to the interstitials to show when completing that step
 */
export type FTUEConversionsInterstitials = FTUEConversionsStepMapping<InterstitialProps[]>;

/**
 * The keys used for the tutorial trainer assets in the image set (comes from
 * the client property)
 */
export const TRAINER_ASSET_KEYS = {
  faceLeft: 'FaceLeft',
  faceRight: 'FaceRight',
};

/** Steps in the FTUE where we want to show the tutorial trainer */
export type TutorialTrainerStep =
  /** Versus screen before the first training match */
  | 'trainingMatch1Versus'

  /** Results screen after the first training match */
  | 'trainingMatch1Results'

  /** Match select screen before the second training match */
  | 'trainingMatch2Select'

  /** Versus screen before the second training match */
  | 'trainingMatch2Versus'

  /** Results screen after the second training match */
  | 'trainingMatch2Results';

export interface TutorialTrainerTextOptions {
  /** Optional map of values to interpolate into the translated text */
  textValues?: Record<string, string | number | undefined>;

  /** Whether to show an overlay behind the tutorial trainer */
  overlayVisible?: boolean;

  /** Whether to show the tutorial trainer name */
  nameVisible?: boolean;
}
